// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:03:33

export default {
  "id": "strategy-of-war-tanks-and-helicopters",
  "slug": "strategy-of-war-tanks-and-helicopters",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/bf7c408186694fcf9f63024901828d81-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/bf7c408186694fcf9f63024901828d81/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Strategy of war. Tanks and helicopters.",
      "description": "\"Strategy of war\" is an exciting strategy war game where the player has to control squads of tanks and helicopters, develop his base, choose battle tactics and fight the enemy.\n\nThe game offers a wide range of equipment and weapons, a variety of missions and tasks, as well as the opportunity to improve and develop their forces. It is important to properly allocate resources, as well as use tactical techniques to defeat the enemy.\n\n\n\n",
      "instructions": "The game \"Strategy of war\" is the implementation of a modern RTS game with the necessary game mechanics, such as base management, command of troops, military tactics (including both defensive and offensive tactics), base capture, ground and air battles.\n\nThe main goal of the game is to capture and hold all enemy bases.\n\nYour base is green. Enemy bases are red and yellow. Neutral bases are gray.\nThe combat units in the game are tanks and helicopters.\n\n\n",
      "genres": [
        "Battle",
        "Strategy"
      ],
      "tags": [
        "helicopter",
        "logic",
        "logical",
        "math",
        "tank"
      ]
    },
    "zh-CN": {
      "title": "战争策略。坦克和直升机。",
      "description": "“战争策略”是一款令人兴奋的策略战争游戏，玩家需要控制坦克和直升机小队，发展自己的基地，选择战斗策略，与敌人战斗。\n\n游戏提供了广泛的装备和武器，各种任务和任务，以及改进和发展他们军队的机会。正确分配资源以及使用战术技巧以击败敌人至关重要。",
      "instructions": "游戏《战争策略》是一款现代即时战略游戏的实现，包含必要的游戏机制，如基地管理、部队指挥、军事战术（包括防御和进攻战术）、基地占领、地面和空中战斗。\n\n游戏的主要目标是占领并守住所有敌方基地。\n\n您的基地是绿色的。敌方基地是红色和黄色的。中立基地是灰色的。\n游戏中的战斗单位是坦克和直升机。",
      "genres": [
        "战斗",
        "策略"
      ],
      "tags": [
        "直升机",
        "逻辑",
        "逻辑的",
        "数学",
        "坦克"
      ]
    },
    "zh-TW": {
      "title": "戰爭策略。坦克與直升機。",
      "description": "\"戰爭策略\"是一款刺激的策略戰爭遊戲，玩家必須操控坦克和直升機隊伍，發展基地，選擇作戰策略，並與敵人作戰。\n\n遊戲提供廣泛的裝備和武器選擇，各種任務和任務，以及提升和發展他們部隊的機會。正確分配資源，以及使用戰術技巧來擊敗敵人非常重要。",
      "instructions": "遊戲《戰略之戰》是現代RTS遊戲的實現，包含必要的遊戲機制，如基地管理、部隊指揮、軍事戰術（包括防禦和攻擊戰術）、基地佔領、地面和空中戰鬥。\n\n遊戲的主要目標是佔領並維持所有敵方基地。\n\n您的基地為綠色。敵方基地為紅色和黃色。中立基地為灰色。\n遊戲中的作戰單位為坦克和直升機。",
      "genres": [
        "戰鬥",
        "策略"
      ],
      "tags": [
        "直升機",
        "邏輯",
        "邏輯的",
        "數學",
        "坦克"
      ]
    },
    "zh-HK": {
      "title": "戰爭策略。坦克及直升機。",
      "description": "戰略大戰是一款刺激的策略戰爭遊戲，玩家需操控坦克和直升機隊伍，發展基地，選擇作戰策略，與敵人作戰。\n\n遊戲提供各種裝備和武器，多樣化的任務和任務，以及提升和發展自己軍力的機會。正確分配資源，以及運用戰術技巧擊敗敵人非常重要。",
      "instructions": "遊戲《戰略戰爭》是實現現代RTS遊戲，並包含必要的遊戲機制，如基地管理、部隊指揮、軍事戰術（包括防禦和攻擊戰術）、基地佔領、地面和空中戰鬥。\n\n遊戲的主要目標是佔領並維持所有敵方基地。\n\n您的基地是綠色。敵方基地是紅色和黃色。中立基地是灰色。\n遊戲中的作戰單位是坦克和直升機。",
      "genres": [
        "戰鬥",
        "策略"
      ],
      "tags": [
        "直升機",
        "邏輯",
        "邏輯的",
        "數學",
        "坦克"
      ]
    },
    "ja": {
      "title": "戦争の戦略。戦車とヘリコプター。",
      "description": "「戦争の戦略」は、プレイヤーが戦車とヘリコプターの隊を統率し、基地を開発し、戦闘戦術を選択し、敵と戦う興味深い戦略戦争ゲームです。\n\nこのゲームは、広範囲な装備と武器、多様なミッションと任務、そして自分たちの軍隊を改善し発展させる機会を提供しています。資源を適切に配分し、戦術的な技術を用いて敵を撃退することが重要です。",
      "instructions": "ゲーム「戦略の戦争」は、基地管理、軍隊の指揮、軍事戦術（防衛と攻撃の両方を含む）、基地の占領、地上と空戦などの必要なゲームメカニクスを持つ現代のRTSゲームの実装です。\n\nゲームの主な目的は、すべての敵基地を占領し、維持することです。\n\nあなたの基地は緑色です。敵基地は赤色と黄色です。中立基地は灰色です。\n\nゲームの戦闘ユニットは戦車とヘリコプターです。",
      "genres": [
        "戦闘",
        "戦略"
      ],
      "tags": [
        "ヘリコプター",
        "論理",
        "論理的",
        "数学",
        "戦車"
      ]
    },
    "ko": {
      "title": "전쟁 전략. 탱크와 헬리콥터.",
      "description": "\"전쟁 전략\"은 플레이어가 탱크와 헬리콥터의 소대를 통제하고, 기지를 개발하고, 전투 전략을 선택하여 적과 싸워야 하는 흥미진진한 전략 전쟁 게임입니다.\n\n이 게임은 다양한 장비와 무기를 제공하며, 다양한 임무와 작업을 포함하여 자신의 부대를 개선하고 발전할 기회를 제공합니다. 자원을 적절히 배분하고 전술적 기술을 사용하여 적을 궤멸시키는 것이 중요합니다.",
      "instructions": "게임 \"전쟁 전략\"은 필요한 게임 메커니즘, 예를 들어 기지 관리, 부대 지휘, 군사 전술(방어와 공격 전술 모두 포함), 기지 점령, 지상과 공중 전투 등을 구현한 현대적인 RTS 게임입니다.\n\n게임의 주요 목표는 모든 적 기지를 점령하고 유지하는 것입니다.\n\n당신의 기지는緑색입니다. 적 기지는 빨간색과 노란색입니다. 중립 기지는 회색입니다.\n게임에서의 전투 단위는 탱크와 헬리콥터입니다.",
      "genres": [
        "전투",
        "전략"
      ],
      "tags": [
        "헬리콥터",
        "논리",
        "논리적",
        "수학",
        "탱크"
      ]
    },
    "fr": {
      "title": "Stratégie de guerre. Tanks et hélicoptères.",
      "description": "\"Stratégie de guerre\" est un jeu de guerre stratégique passionnant où le joueur doit contrôler des escadrons de chars et d'hélicoptères, développer sa base, choisir des tactiques de bataille et combattre l'ennemi.\n\nLe jeu propose une large gamme d'équipements et d'armes, une variété de missions et de tâches, ainsi que la possibilité d'améliorer et de développer leurs forces. Il est important de bien allouer les ressources, ainsi que d'utiliser des techniques tactiques pour vaincre l'ennemi.",
      "instructions": "Le jeu \"Strategy of war\" est une mise en œuvre d'un jeu de stratégie en temps réel moderne avec les mécanismes de jeu nécessaires, tels que la gestion de base, la commande des troupes, les tactiques militaires (y compris les tactiques défensives et offensives), la capture de base, les batailles terrestres et aériennes.\n\nL'objectif principal du jeu est de capturer et de conserver toutes les bases ennemies.\n\nVotre base est verte. Les bases ennemies sont rouges et jaunes. Les bases neutres sont grises.\nLes unités de combat dans le jeu sont les chars et les hélicoptères.",
      "genres": [
        "Bataille",
        "Stratégie"
      ],
      "tags": [
        "helicoptère",
        "logique",
        "logique",
        "mathématiques",
        "char"
      ]
    }
  }
};
